import {
  DomainEvent,
  InternalQueryCommand,
  QueryProcessor,
} from '@withlocals/cqrs.js/lib';
import { AccountUpdated } from 'aggregates/account/commands';
import isEqual from 'lodash.isequal';
import { Observable, Subject } from 'rxjs';
import { TrackJS } from 'trackjs';

import { AuthenticationInfo } from '../../model/AuthenticationInfo';
import { Account } from '../../model/IChat';
import { AccountApi } from './client';

class InternalRefreshAccountCommand implements InternalQueryCommand {}

export interface AccountState {
  loading: boolean;
  fromCache?: boolean;
  offline?: boolean;
  account?: Account;
}

export class AccountQueryProcessor extends QueryProcessor {
  private client: AccountApi;

  constructor(protected authInfo: AuthenticationInfo) {
    super();
    this.client = new AccountApi(authInfo);
  }

  private reducer = (e: DomainEvent, prevState: AccountState) => {
    console.debug(`AccountQueryProcessor$.reduce`, e);
    if (e instanceof InternalRefreshAccountCommand) {
      return this.client.getCurrent();
    }
    if (e instanceof AccountUpdated) {
      return this.client.getCurrent();
    }
    return prevState;
  };

  private reducerReal = (e: DomainEvent, prevState: AccountState) => {
    console.debug(`AccountQueryProcessor$.reducerReal`, e);
    if (e instanceof InternalRefreshAccountCommand) {
      return this.client.getReal();
    }
    return prevState;
  };

  private internalSource = new Subject<InternalQueryCommand>();
  private fullSource = Observable.merge(
    this.internalSource,
    this.source.share(),
  );

  readonly account$ = this.reduce<AccountState>(
    this.reducer,
    { loading: true },
    this.fullSource.startWith(new InternalRefreshAccountCommand()),
  )
    .distinctUntilChanged(isEqual)
    .shareReplay(1)
    .do((accountState) => {
      if (accountState.account) {
        TrackJS.addMetadata('user_id', accountState.account?.id);
      }
    });

  readonly realAccount$ = this.reduce<AccountState>(
    this.reducerReal,
    { loading: true },
    this.fullSource.startWith(new InternalRefreshAccountCommand()),
  )
    .distinctUntilChanged(isEqual)
    .shareReplay(1)
    .do((accountState) => console.debug('realAccount$', accountState));
}
